module.exports = __webpack_public_path__ + "img/avator.b23a15fa.png";